import { gatewayServices } from "src/common/apiUrl";
import { ZUid } from "src/types/zUid";
import { rest, stdParamsSerializer } from "src/common/rest";
import z from "zod";
import { Mc2Fields, zMc2, ZMc2, zMc2Settings, ZMc2Settings } from "./Mc2Types";

export const urlMc2 = (path: string) =>
  gatewayServices(`/measurement-chart-service/v2/api${path}`);

export const loadMc2Settings = async (
  objectId: ZUid,
): Promise<ZMc2Settings> => {
  const resp = await rest.get(urlMc2("/settings"), { params: { objectId } });
  return zMc2Settings.parse(resp.data);
};

export const loadMc2Permissions = async (objectId: ZUid): Promise<string[]> => {
  const resp = await rest.get(urlMc2("/settings/permissions"), {
    params: { objectId },
  });
  return z.string().array().parse(resp.data);
};

export const saveMc2Settings = async (
  objectId: ZUid,
  serviceId: ZUid,
  data: ZMc2Settings,
) => {
  await rest.put(urlMc2("/settings"), data, {
    params: { objectId, serviceId },
  });
};

// MC CRUD

export const loadMc2Summary = async (modelEntityId: ZUid): Promise<ZMc2[]> => {
  const resp = await rest.get(urlMc2("/measurement-chart/list"), {
    params: { modelEntityId },
  });
  return zMc2.array().parse(resp.data);
};

export const createMc2 = async (
  modelEntityId: ZUid,
  data: Mc2Fields,
): Promise<void> => {
  await rest.post(urlMc2("/measurement-chart"), data, {
    params: { modelEntityId },
  });
};

export const loadMc2Entity = async (mcEntityId: ZUid): Promise<ZMc2> => {
  const resp = await rest.get(urlMc2("/measurement-chart"), {
    params: { mcEntityId },
  });
  return zMc2.parse(resp.data);
};

export const updateMc2 = async (
  mcEntityId: ZUid,
  data: ZMc2,
): Promise<ZMc2> => {
  const resp = await rest.put(urlMc2("/measurement-chart"), data, {
    params: { mcEntityId },
  });
  return zMc2.parse(resp.data);
};

export const deleteMcs2 = async (mcEntityId: ZUid[]): Promise<void> => {
  await rest.delete(urlMc2("/measurement-chart"), {
    params: { mcEntityId },
    paramsSerializer: stdParamsSerializer,
  });
};

export const copyMc2Entities = async (data: {
  mcEntityIdsFrom: ZUid[];
  modelEntityIdsTo: ZUid[];
}) => {
  await rest.post(urlMc2("/copy"), data);
};
